"use client";

import RecaptchaProvider from "@components/providers/google/recaptcha-provider";

export default function RecaptchaWrapper({children}) {
    return (
        <RecaptchaProvider>
            {children}
        </RecaptchaProvider>
    );
}